import { render } from "./Spinner.vue?vue&type=template&id=768eb5d4&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=768eb5d4&lang=postcss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768eb5d4"]])

export default __exports__